import { defineComponent as z, ref as r, watch as C, computed as n, nextTick as K } from "vue";
import { debounce as _, isEqual as U, uniqueId as N, isUndefined as R, isNull as W, uniq as G, without as H } from "lodash-es";
import J from "./td-longtail-vue-components77.js";
import P from "./td-longtail-vue-components79.js";
import Q from "./td-longtail-vue-components20.js";
import X from "./td-longtail-vue-components3.js";
import { filteredOptions as Y } from "./td-longtail-vue-components82.js";
const ae = /* @__PURE__ */ z({
  __name: "list-dropdown",
  props: {
    placeholder: { default: void 0 },
    value: { default: null },
    options: null,
    multiple: { type: Boolean, default: !1 },
    label: { default: void 0 },
    includeBlank: { default: void 0 },
    labelOnSelection: { type: Boolean, default: !0 },
    itemUrl: { type: Function, default: void 0 },
    buttonText: { default: "Übernehmen" },
    opened: { type: Boolean },
    disabled: { type: Boolean },
    hasSearch: { type: Boolean },
    autoWidth: { type: Boolean },
    groupEntries: { type: Boolean },
    breakText: { type: Boolean },
    emptyText: { default: "Kein Eintrag vorhanden" },
    updateText: { default: "Ergebnis gefunden" },
    updateTexts: { default: "Ergebnisse gefunden" },
    placeholderText: { default: "Liste Filtern" },
    showEmptyContent: { type: Boolean }
  },
  emits: ["unselect", "select", "input", "change", "toggle"],
  setup(k, { expose: q, emit: o }) {
    const t = k;
    function x(e, a) {
      return R(e) || W(e) ? a ? [] : null : e;
    }
    const l = r(t.multiple ? [] : void 0), T = r(""), d = r(""), u = r(null), f = r(null), A = _(() => {
      d.value = T.value;
    }, 200);
    C(
      () => t.value,
      (e) => {
        l.value = x(e, t.multiple);
      },
      {
        immediate: !0
      }
    );
    const m = n(() => l.value === void 0 ? [] : t.multiple ? l.value : [l.value]), i = (e) => m.value.some((a) => U(a, e)), p = n(() => {
      if (!(t.multiple || !t.options))
        return t.options.find((e) => i(e.value));
    }), h = n(() => !t.multiple || !t.options ? [] : t.options.filter((e) => i(e.value))), s = n(() => t.multiple ? h.value : p.value), g = n(() => t.multiple ? s.value?.length > 0 : !!s.value), D = n(() => g.value ? t.multiple ? h.value.map((e) => e.label).sort().join(", ") : p.value?.label || "" : ""), L = n(() => {
      if (!(!g.value || t.multiple))
        return p.value;
    }), B = n(() => !U(t.value, l.value)), V = n(() => ({
      "dropdown--simple": !t.multiple,
      "dropdown--multi": t.multiple
    })), b = n(
      () => Y(d.value, t.options || [], t.groupEntries)
    ), $ = n(
      () => t.disabled || !t.showEmptyContent && (t.options?.length || 0) === 0
    ), c = (e) => {
      u.value?.announceOption && u.value.announceOption(e);
    };
    C(b, (e) => {
      if (!t.hasSearch || !u.value || !u.value.openable.isOpened) {
        c("");
        return;
      }
      _(() => {
        const a = e.length || 0;
        c(`${a} ${a === 1 ? t.updateText : t.updateTexts}`);
      }, 200)();
    });
    const w = () => {
      l.value = t.value;
    }, F = (e) => {
      if (o("toggle", e), !e) {
        c(""), w();
        return;
      }
      K(() => {
        f.value && f.value.focus();
      });
    }, v = (e) => {
      e === void 0 ? l.value = t.multiple ? [] : void 0 : t.multiple ? l.value = G([...l.value, e?.value]) : l.value = e?.value, o("select", e?.value, l.value);
    }, y = (e) => {
      t.multiple ? l.value = H(l.value, e.value) : l.value === e.value && (l.value = void 0), o("unselect", e.value, l.value);
    }, E = (e) => {
      i(e.value) ? y(e) : v(e);
    }, O = () => {
      l.value = t.multiple ? [] : void 0;
    }, S = () => {
      o("input", l.value), o("change", s.value), u.value?.close();
    }, M = (e) => {
      e == null ? O() : t.multiple ? E(e) : v(e), t.multiple || S();
    }, j = (e) => {
      if (!(!t.itemUrl || !e))
        return t.itemUrl(e);
    }, I = n(() => u.value?.openable);
    return q({
      internalValue: l,
      select: v,
      unselect: y,
      isSelected: i,
      selection: s,
      filteredOptions: b,
      debouncedSearchInput: d,
      selectedValues: m,
      hasChanged: B,
      openable: I
    }), { __sfc: !0, sanitizeValue: x, props: t, emit: o, internalValue: l, searchInput: T, debouncedSearchInput: d, dropdownElement: u, searchInputElement: f, updateSearchResults: A, selectedValues: m, isSelected: i, selectedSingle: p, selectedMultiple: h, selection: s, hasSelection: g, selectedLabels: D, selectedOption: L, hasChanged: B, containerClass: V, filteredOptions: b, isDisabled: $, setAnnounceText: c, reset: w, onToggle: F, select: v, unselect: y, toggleSelection: E, unselectAll: O, change: S, selectAndMaybeChange: M, buildItemUrl: j, openable: I, uniqueId: N, Dropdown: J, DropdownItem: P, TextInput: Q, LinkButton: X };
  }
});
export {
  ae as default
};
